<button
  [ngClass]="{
    'primary-background': background === 'primary',
    'secondary-background': background === 'secondary',
    'border-only': background === 'white'
  }"
  class="iso-round-nofill-button position-relative"
>
  <span class="icon-wrapper">
    <daz-icon
      [color]="iconColor"
      [name]="icon"
      [ngStyle]="{ left: left, right: right, top: top, bottom: bottom }"
      [size]="'20px'"
      class="daz-style"
    ></daz-icon>
  </span>

  <span *ngIf="showNotification" class="notification-dot"></span>
</button>
